export default "__VITE_ASSET__55b23581__"